import React from "react";
import "./index.scss";
import Text from "features/components/text";
import {withTranslation} from "react-i18next";
import {Icon} from "features/components/icon";

export const Errors = (props) => {
    const {errors, t} = props;
    if(!errors) {
        return null;
    }
    return <div className="errors">
        {
            errors.map(i => <div key={i}>
                <Icon>alert</Icon>
                <Text size={18}>{t(i)}</Text>
            </div>)
        }
    </div>
};

export default withTranslation()(Errors);
